module.exports = __webpack_public_path__ + "static/media/unreleased-generative-art-by-lucastswick-thumb-4.ccde2472.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/unreleased/unreleased-generative-art-by-lucastswick-thumb-4.jpg
// module id = 4564
// module chunks = 15